import BestYoungRider from "../../icons/_custom_tour_of_britain/Best-Young-Rider";
import BORA from "../../icons/_custom_tour_of_britain/BORA";
import BingoalPauwelsSaucesWB from "../../icons/_custom_tour_of_britain/Bingoal-Pauwels-Sauces-WB";
import Bolton from "../../icons/_custom_tour_of_britain/Bolton";
import EquipoKern from "../../icons/_custom_tour_of_britain/Equipo_Kern";
import FinishFlag from "../../icons/_custom_tour_of_britain/FinishFlag";
import GB from "../../icons/_custom_tour_of_britain/GB";
import Global6 from "../../icons/_custom_tour_of_britain/Global_6";
import Flanders from "../../icons/_custom_tour_of_britain/Flanders";
import INEOS from "../../icons/_custom_tour_of_britain/INEOS";
import Jumbo from "../../icons/_custom_tour_of_britain/Jumbo";
import KM0 from "../../icons/_custom_tour_of_britain/KM0";
import KOM from "../../icons/_custom_tour_of_britain/KOM";
import Leader from "../../icons/_custom_tour_of_britain/Leader";
import PinarelloKoM from "../../icons/_custom_tour_of_britain/Pinarello-KoM";
import Points from "../../icons/_custom_tour_of_britain/Points";
import Q365 from "../../icons/_custom_tour_of_britain/Q36-5";
import SaintPiran from "../../icons/_custom_tour_of_britain/Saint_Piran";
import Movistar from "../../icons/_custom_tour_of_britain/Movistar";
import StageWinner from "../../icons/_custom_tour_of_britain/Stage-winner";
import TDT from "../../icons/_custom_tour_of_britain/TDT";
import TRINITY from "../../icons/_custom_tour_of_britain/TRINITY";
import UnoX from "../../icons/_custom_tour_of_britain/UnoX";
import Dsm from "../../icons/_custom_tour_of_britain/dsm";
import Start from "../../icons/_custom_tour_of_britain/start";
import Sprint from "../../icons/_custom_tour_of_britain/sprint";
import {SportstypeSpec} from "../types";


const _custom_tour_of_britain: SportstypeSpec = {
  id: '_custom_tour_of_britain',
  svg: Start,
  releaseStage: 'released',
  events: [
    {
      id: 'BORA',
      important: false,
      svg: BORA
    },
    {
      id: 'BestYoungRider',
      important: false,
      svg: BestYoungRider
    },
    {
      id: 'BingoalPauwelsSaucesWB',
      important: false,
      svg: BingoalPauwelsSaucesWB
    },
    {
      id: 'Bolton',
      important: false,
      svg: Bolton
    },
    {
      id: 'Dsm',
      important: false,
      svg: Dsm
    },
    {
      id: 'EquipoKern',
      important: false,
      svg: EquipoKern
    },
    {
      id: 'Flanders',
      important: false,
      svg: Flanders
    },
    {
      id: 'FinishFlag',
      important: false,
      svg: FinishFlag
    },
    {
      id: 'GB',
      important: false,
      svg: GB
    },
    {
      id: 'Global6',
      important: false,
      svg: Global6
    },
    {
      id: 'INEOS',
      important: false,
      svg: INEOS
    },
    {
      id: 'Jumbo',
      important: false,
      svg: Jumbo
    },
    {
      id: 'KM0',
      important: false,
      svg: KM0
    },
    {
      id: 'KOM',
      important: false,
      svg: KOM
    },
    {
      id: 'Leader',
      important: false,
      svg: Leader
    },
    {
      id: 'Movistar',
      important: false,
      svg: Movistar
    },
    {
      id: 'PinarelloKoM',
      important: false,
      svg: PinarelloKoM
    },
    {
      id: 'Points',
      important: false,
      svg: Points
    },
    {
      id: 'Q365',
      important: false,
      svg: Q365
    },
    {
      id: 'SaintPiran',
      important: false,
      svg: SaintPiran
    },
    {
      id: 'Sprint',
      important: true,
      svg: Sprint
    },
    {
      id: 'StageWinner',
      important: false,
      svg: StageWinner
    },
    {
      id: 'Start',
      important: true,
      svg: Start
    },
    {
      id: 'TDT',
      important: false,
      svg: TDT
    },
    {
      id: 'TRINITY',
      important: false,
      svg: TRINITY
    },
    {
      id: 'UnoX',
      important: false,
      svg: UnoX
    }
  ]
}

export default _custom_tour_of_britain
